import classnames from "classnames";
import { Component } from "react";
import { type WithRouterProps, withRouter } from "nvent-web/utils/withRouter";

import ArrowRightIcon from "nvent-web/assets/svg/arrow-right.svg";
import { type BuildingType } from "nvent-web/types/BuildingType";
import { type ProjectInsulationItem } from "nvent-web/types/ProjectInsulationItem";

import style from "./ProjectInsulationCard.module.scss";
import compose from "~/nvent-web/utils/compose";

interface ProjectInsulationCardParams {
  projectId: string;
  roomId: string;
}

export interface ProjectInsulationCardProps
  extends ProjectInsulationItem, ProjectInsulationCardParams, WithRouterProps {
  selected: boolean;
  onSelect: (state: BuildingType) => void;
  containerClassName?: string;
}

class ProjectInsulationCard extends Component<ProjectInsulationCardProps> {
  render() {
    const { icon, title, description, selected, containerClassName } =
      this.props;

    return (
      <div className={style.wrapper}>
        <div
          onClick={this.onChooseProjectIsolation}
          role="link"
          tabIndex={0}
          className={classnames(style.container, containerClassName, {
            [style.selected]: selected,
          })}
        >
          <div
            className={classnames(style.iconContainer, {
              [style.selected]: selected,
            })}
          >
            {icon}
          </div>
          <div className={style.content}>
            <h3
              className={classnames(style.title, {
                [style.selected]: selected,
              })}
            >
              {title}
            </h3>
            <p className={style.description}>{description}</p>
          </div>
          <div
            className={classnames(style.arrowIconContainer, {
              [style.selected]: selected,
            })}
          >
            <img src={ArrowRightIcon} className={style.arrowIcon} />
          </div>
        </div>
      </div>
    );
  }

  private onChooseProjectIsolation = () => {
    this.props.onSelect(this.props.buildingType);
  };
}

const ProjectInsulationCardComponent = compose<
  ProjectInsulationItem &
    Pick<
      ProjectInsulationCardProps,
      "onSelect" | "selected" | "containerClassName"
    >
>(withRouter)(ProjectInsulationCard);

ProjectInsulationCardComponent.displayName = "ProjectInsulationCard";

export default ProjectInsulationCardComponent;
